module.exports = {"id":"216742","name":"Miha Mevlja","rating":"75","photo":"./data/images/photos/0/216742.png","club":{"name":"Zénith","logo":"./data/images/clubs/Zenith.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MihaMevlja0.json
// module id = 3015
// module chunks = 0